import { type InternalAxiosRequestConfig } from 'axios';
import { getAuthHeader } from './getAuthHeader';

export const SetAuthHeader = async (
    config: InternalAxiosRequestConfig<any>
) => {
    const header = await getAuthHeader();
    config.headers['X-Auth-Token'] = header;
    return config;
};